import Item from "./item.vue";
import Frame from "./frame.vue";
export default {
    Name: "DataInterMenu",
    ItemIs: "DataInterMenuItem",
    Is: "DataInterMenuFrame",
    Components: {
        DataInterMenuFrame: Frame,
        DataInterMenuItem: Item
    },
    CreateDataConfig: function (config) {
        let dataconfig = Object.assign({},config.Config);
        if (!dataconfig.PageSize) {
            dataconfig.PageSize = 10;
        }
        if (!dataconfig.Fields) {
            dataconfig.Fields = ["IdCount"];
        }
        return dataconfig;
    }
};
